<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="reservationsList"
      :items-per-page="10"
      class="elevation-1"
      :custom-filter="customFilter"
    >
      <template v-slot:item.userName="{ item }">
        <tr>
          {{
            item.mediaData.userName
          }}
        </tr>
      </template>
      <template v-slot:item.emailAddress="{ item }">
        <tr>
          {{
            item.mediaData.emailAddress
          }}
        </tr>
      </template>
      <template v-slot:item.clientName="{ item }">
        <tr>
          {{
            item.mediaData.clientName
          }}
        </tr>
      </template>
      <template v-slot:item.note="{ item }">
        <tr>
          {{
            item.mediaData.note
          }}
        </tr>
      </template>
      <template v-slot:item.createdAt="{ item }">
        <tr>
          {{
            item.createdAt
          }}
        </tr>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon
          small
          class="mr-3"
          @click="openDialog(item, item.mediaData.reservedList)"
          >mdi-eye-outline</v-icon
        >
      </template>
    </v-data-table>
    <v-dialog v-model="showDialog">
      <v-list-item>
        <v-list-item-content>
          <v-data-table
            :headers="aptHeaders"
            :items="apartmentsToShow"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:top>
              <button
                @click="downloadTemplateFile(selectedReservation)"
                download
              >
                Download passport photo
              </button>
            </template>
            <template v-slot:item.name="{ item }">
              <tr>
                {{
                  item.name
                }}
              </tr>
            </template>
            <template v-slot:item.area="{ item }">
              <tr>
                {{
                  item.area
                }}
              </tr>
            </template>
            <template v-slot:item.floor="{ item }">
              <tr>
                {{
                  item.floor
                }}
              </tr>
            </template>
            <template v-slot:item.status="{ item }">
              <tr>
                {{
                  item.properties.status
                }}
              </tr>
            </template>
            <template v-slot:item.price="{ item }">
              <tr>
                {{
                  item.properties.price
                }}
              </tr>
            </template>
          </v-data-table>
        </v-list-item-content>
      </v-list-item>
    </v-dialog>
  </div>
</template>

<script>
const fileDownload = require('js-file-download')
import { FilesGetMixin } from '../../mixins/FilesGetMixin'
export default {
  name: 'reservationsList',
  props: {
    reservationsList: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    }
  },
  components: {},
  mixins: [FilesGetMixin],
  data: function() {
    return {
      headers: [
        {
          text: 'User',
          align: 'left',
          sortable: true,
          value: 'userName'
        },
        {
          text: 'Client email',
          align: 'left',
          sortable: true,
          value: 'emailAddress'
        },
        {
          text: 'Client name',
          align: 'left',
          sortable: true,
          value: 'clientName'
        },

        { text: 'Notes', align: 'left', sortable: true, value: 'note' },
        { text: 'Created', align: 'left', sortable: true, value: 'createdAt' },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ],
      aptHeaders: [
        { text: 'Name', align: 'left', sortable: true, value: 'name' },
        {
          text: 'Area',
          align: 'left',
          sortable: true,
          value: 'area'
        },

        { text: 'Floor', align: 'left', sortable: true, value: 'floor' },
        { text: 'Status', align: 'left', sortable: true, value: 'status' },
        { text: 'Price', align: 'left', sortable: true, value: 'price' }
      ],
      stateOptions: {},
      mounted: false,
      search: '',
      showDialog: false,
      apartmentsToShow: [],
      selectedReservation: null
    }
  },

  computed: {},
  watch: {},
  created: function() {
    //this.$store.dispatch("BuildingStore/fetchBuildings");
    this.stateOptions = localStorage.reservationsListOptions
      ? JSON.parse(localStorage.reservationsListOptions)
      : {}
  },
  mounted: function() {
    this.mounted = true
  },
  methods: {
    customFilter(value, search, item) {
      //var exp = new RegExp(search, "i");
      return new RegExp(search, 'i').test(item.name)
      // search = search.toString().toLowerCase();
      // return items.filter(row => filter(row["name"], search));
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    openDialog(reservation, list) {
      this.apartmentsToShow = list
      this.selectedReservation = reservation
      this.showDialog = true
    },
    async downloadTemplateFile(media) {
      // await this.$store.dispatch('MediaStore/setMediaContext', 'project')
      // let resp = await this.$store.dispatch('MediaStore/getFile', media)
      // let blob = new Blob([resp], { type: 'application/jpg' })
      // //const blob = await fetch(retVal).then(res => res.blob())
      // //let blob = resp.blob()
      // let link = document.createElement('a')
      // link.href = window.URL.createObjectURL(blob)
      // link.download = media.path
      // link._target = 'blank'
      // link.click()
      const response = await this.getFile(media)

      fileDownload(JSON.stringify(response), media.path)
    }
  }
}
</script>

<style scoped></style>
